import React from 'react';
import {FormattedMessage} from "react-intl";
import {hashHistory} from "react-router";

const AgentPageFooter = () => {

  const handleFooterCancelClick = () => {
    hashHistory.push("/");
  }

  return (
    <div className="app-content-footer app-content-footer--fixed">
      <div className="app-content-footer__buttons">
        <button className="ui-button ui-button--blue" onClick={handleFooterCancelClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.back"/>
          </span>
        </button>
      </div>
    </div>
  )
};

export default AgentPageFooter;
